import { render, staticRenderFns } from "./InvoiceItemBulk.vue?vue&type=template&id=47d8f30a"
import script from "./InvoiceItemBulk.vue?vue&type=script&lang=js"
export * from "./InvoiceItemBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports